
import React, { Fragment } from 'react';
import { ArcaHttpLogging } from '../../code/ArcaHttpLogging';
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { ArcaDate } from '../../code/Types/ArcaDate';
import { LogItem } from "../controls/Logging/LogItem";
import { LoginPanel } from "../controls/Security/LoginPanel";
import { StatusBar } from '../controls/StatusBar';
import { ArcaComponent } from './ArcaComponent';
import { DateWrapper } from '../controls/Datepickers/DateWrapper';

export class Logging extends ArcaComponent {
    constructor(props) {
        super(props);

        this.state = {
            logs: null,
            referenceDate: ArcaDate.Today,
            statusText: null,
            isError: false,
            isLoading: true,

            focusedInput: false
        };
    }

    async componentDidMount() {
        await this.getScreenDetails(this.state.referenceDate);
    }

    async getScreenDetails(date) {
        await ArcaHttpLogging.GetAsync(
            date,
            ((logs, date) => this.setState({
                logs,
                referenceDate: date,
                isLoading: false,
                statusText: null,
                isError: false,
            })),
            ((msg) => this.setState({
                isError: false,
                referenceDate: date,
                logs: null,
                isLoading: false,
                statusText: `No logs found`
            })),
            ((msg) => this.setState({
                isError: true,
                logs: null,
                statusText: msg
            }))
        );
    }

    handleDateChange(e) {

        if (e.target.value === '') {
            return
        }

        var selectedDate = new ArcaDate(new Date(e.target.value))

        if (ArcaDate.Today.IsLater(selectedDate)) {
            this.setState({
                isError: false,
                statusText: `Ignoring future dates`
            })
            return;
        }

        this.getScreenDetails(selectedDate)
    }

    render() {
        let { referenceDate } = this.state
        return (
            <div>

                {!ArcaSecurity.IsLoggedIn
                    ? <LoginPanel onLogon={(() => this.handleDateChange(new Date()))} />
                    : <Fragment>

                        {ArcaSecurity.IsAdmin
                            ? <span>
                                <h1 className='centerText'>Logging</h1>

                                <h3 className='centerText'>
                                    <DateWrapper
                                        referenceDate={referenceDate}
                                        handleDateChange={(e) => this.handleDateChange(e)} />
                                </h3>

                                <StatusBar isError={this.state.isError} message={this.state.statusText} />


                                {!this.state.isLoading
                                    ? <Fragment>
                                        {this.state.logs
                                            ? <Fragment>
                                                <h5 className='centerText'>The days logs are below.</h5>

                                                {this.state.logs?.map((log, key) =>
                                                    <LogItem log={log} key={key} />
                                                )}
                                            </Fragment>
                                            : null}
                                    </Fragment>
                                    : <h5>Page is loading ...</h5>}


                            </span >
                            : <span>
                                <h1 className='centerText'>Access denied!</h1>
                            </span>
                        }
                    </Fragment>}
            </div>
        );
    }
}
